/**
 * Blank state for a chat that lives in a side panel.
 *
 * The group sits at the bottom of the free space, so the copy reads directly above its suggestions
 * and the suggestions directly above the composer. Copy is per surface rather than fixed, because a
 * panel should open saying something true about the thing it is attached to.
 */
export const PanelEmptyState = ({
  heading,
  description,
  suggestions,
  onSuggestionClick,
}: {
  heading: string;
  description: string;
  suggestions: readonly string[];
  onSuggestionClick: (text: string) => void;
}) => (
  <div className="flex min-h-0 flex-1 flex-col justify-end gap-5xl px-lg pb-3xl">
    <div className="flex flex-col items-center gap-sm text-center">
      {/* The design's Display xs/Medium is 600; `display-xs-medium` renders 500. */}
      <p className="font-mulish text-2xl font-semibold leading-8 tracking-[-2%] text-text-primary">
        {heading}
      </p>
      <p className="txt-small-regular text-text-secondary">{description}</p>
    </div>
    {suggestions.length > 0 && (
      <div className="flex shrink-0 flex-wrap items-center justify-center gap-sm">
        {suggestions.map((suggestion) => (
          <button
            key={suggestion}
            type="button"
            onClick={() => onSuggestionClick(suggestion)}
            className="flex h-4xl cursor-pointer items-center rounded-full border-1/2 border-border-primary bg-bg-secondary px-lg py-sm txt-small-regular text-text-primary transition-colors hover:bg-bg-secondary-hover"
          >
            {suggestion}
          </button>
        ))}
      </div>
    )}
  </div>
);
